export function createPermissionNavigationResolver(fetchPermissions) {
  let backgroundRefreshStarted = false;

  return async function resolvePermissionsBeforeNavigation(permissionsLoaded) {
    if (!permissionsLoaded) {
      await fetchPermissions();
      return;
    }

    if (backgroundRefreshStarted) return;
    backgroundRefreshStarted = true;

    try {
      Promise.resolve(fetchPermissions()).catch(() => undefined);
    } catch (_) {
      // Cache pozwala kontynuować nawigację także przy awarii odświeżenia.
    }
  };
}
